// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Links */
a {
    color: var(--bs-body-color);
    text-decoration: none;
}

a:hover {
    color: var(--bs-primary);
}

a:focus,
a:focus-within,
a:focus-visible {
    outline: none;
    box-shadow: none;
}

/* Colors */
.bg-light-pink {
    background: linear-gradient(97.59deg, #F4EDFA 4.58%, #DDD3E5 100.08%);
}

.bg-light-green {
    background: linear-gradient(97.03deg, #EDFAF2 1.08%, #D1E0D7 99.84%);
}

.bg-light-blue {
    background: linear-gradient(96.64deg, #EDF3FA 0.59%, #CBD3DC 99.22%);
}

.bg-light-orange {
    background: linear-gradient(97.54deg, #FAEDED 2.68%, #E8DADA 98.28%);
}

.bg-light-gray {
    background-color: var(--light-gray) !important;
}

.bg-card {
    background-color: var(--bs-card-bg) !important;
}

.border-bg {
    background: var(--bs-border-color);
}

.text-black-50 {
    color: var(--text-black-50) !important;
}

/* Typography */
.fs-0 {
    font-size: 0px;
}

.fs-12 {
    font-size: 12px;
}

.fs-14 {
    font-size: 14px;
}

.fs-18 {
    font-size: 18px;
}

.fs-20 {
    font-size: 20px;
}

.fs-24 {
    font-size: 24px;
}

.lh-20 {
    line-height: 20px;
}

.lh-28 {
    line-height: 28px;
}

.minw-190 {
    min-width: 190px;
}

.form-label {
    margin-bottom: .2rem;
    font-size: 14px;
    opacity: .7;
}

.drod-arrow-none::after {
    display: none;
}

.dropdown-item.active,
.dropdown-item:active {
    background-color: var(--bs-primary);
}

.row-deck>[class*=col-] {
    display: flex;
}

.row-deck>.col .card,
.row-deck>[class*=col-] .card {
    flex: 1 1 auto;
}

/* Table css */
.table-nowrap tr td {
    white-space: nowrap;
}

/* Avatar */
.avatar.xs {
    min-width: 18px;
    width: 18px;
    height: 18px;
}

.avatar.sm {
    min-width: 24px;
    width: 24px;
    height: 24px;
}

.avatar.md {
    min-width: 32px;
    width: 32px;
    height: 32px;
}

.avatar.lg {
    min-width: 46px;
    width: 46px;
    height: 46px;
}

.avatar.xl {
    min-width: 60px;
    width: 60px;
    height: 60px;
}

.avatar.xxl {
    min-width: 120px;
    width: 120px;
    height: 120px;
}

.thumbnail {
    background-color: var(--bs-primary);
}

.avatar-group {
    padding-left: 16px;
}

.avatar-group .avatar-item.sm {
    margin-left: -5px;
}

.avatar-group .avatar-item.md {
    margin-left: -10px;
}

.avatar-group .avatar-item.lg {
    margin-left: -16px;
}

.avatar-group .avatar-item:hover {
    z-index: 99;
    transition: var(--transition-3s);
    transform: translateY(-2px)
}

/* Border */
.border-dashed {
    border-style: dashed !important;
}

.border-top-dashed {
    border-top-style: dashed !important;
}

/* Border */

/* Buttons */
.btn-check:checked+.btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check)+.btn:active {
    border-color: transparent;
}

.btn-check:checked+.btn:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible,
.btn:first-child:active:focus-visible,
:not(.btn-check)+.btn:active:focus-visible {
    box-shadow: none;
}

.btn:focus-visible,
.nav-link:focus-visible {
    box-shadow: none;
}

/* Buttons Primary */
.btn-primary,
.btn-primary:focus,
.btn-primary:hover,
.btn-primary:active,
.btn.btn-primary:first-child:active {
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
}

.btn-primary:hover {
    transition: var(--transition-3s);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

/* Buttons Primary Outline */
.btn-outline-primary,
.btn-outline-primary:focus {
    color: var(--bs-primary);
    border-color: var(--bs-primary);
}

.btn-outline-primary {
    --bs-btn-color: var(--bs-primary);
    --bs-btn-border-color: var(--bs-primary);
    --bs-btn-hover-bg: var(--bs-primary);
    --bs-btn-hover-border-color: var(--bs-primary);
    --bs-btn-active-bg: var(--bs-primary);
    --bs-btn-active-border-color: var(--bs-primary);
    --bs-btn-disabled-color: var(--bs-primary);
    --bs-btn-disabled-border-color: var(--bs-primary);
}

.btn-link {
    --bs-btn-color: var(--bs-primary);
    --bs-btn-hover-color: var(--bs-link-hover-color);
    --bs-btn-active-color: var(--bs-link-hover-color);
}

/* button */

/* On Hover SVG stroke witdh */
.hover-svg svg path {
    stroke: var(--bs-body-color);
    transition: var(--transition-3s);
}

.hover-svg:hover svg path {
    stroke-width: 2px;
    stroke: var(--bs-primary);
    transition: var(--transition-3s);
}

.hover-svg.active svg path {
    stroke: inherit;
}

.text-success:hover svg path {
    stroke-width: 2px;
    stroke: var(--bs-success);
    transition: var(--transition-3s);
}

.text-primary:hover svg path {
    stroke-width: 2px;
    stroke: var(--bs-primary);
    transition: var(--transition-3s);
}

.text-secondary:hover svg path {
    stroke-width: 2px;
    stroke: var(--bs-secondary);
    transition: var(--transition-3s);
}

.text-danger:hover svg path {
    stroke-width: 2px;
    stroke: var(--bs-danger);
    transition: var(--transition-3s);
}

/* Resize */
.resize-none {
    resize: none;
}

/* Page Breadcrumbs */
.page-breadcrumbs {
    background-color: var(--bs-card-bg);
    font-size: 18px;
    position: sticky;
    top: 78px;
    z-index: 1021;
}

.page-breadcrumbs .back-btn {
    min-width: 221px;
    border-right: 1px solid var(--bs-border-color);
}

/* Form Control */
.form-select:focus {
    border-color: var(--bs-primary);
    box-shadow: 0 0 0 .25rem rgba(var(--bs-primary-rgb), .25);
}

.form-control:hover {
    border-color: rgba(var(--bs-primary-rgb), .25);
}

.form-control:focus-visible,
.form-select:focus-visible {
    outline-offset: 3px;
    outline-width: 1px;
    outline-style: dashed;
    outline-color: rgba(var(--bs-primary-rgb), .5);
}

.form-control:focus,
.form-check-input:focus {
    box-shadow: none;
    border-color: var(--bs-primary);
}

.control-group:has(textarea:focus) label,
.control-group:has(select:focus) label,
.control-group:has(input:focus) label {
    color: var(--bs-primary);
}

.form-control-lg,
.form-select-lg {
    padding: .9rem 1rem;
    font-size: 1rem;
}


.form-check-input:checked {
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
}

.form-check-input {
    width: 1.3em;
    height: 1.3em;
    margin: 0;
}

input[type="time"],
input[type="date"] {
    text-align: left;
    text-align-last: left;
}

input[type="time"]::-webkit-date-and-time-value,
input[type="date"]::-webkit-date-and-time-value {
    text-align: left;
}

input[type="time"]::-webkit-datetime-edit,
input[type="date"]::-webkit-datetime-edit {
    text-align: left;
}

/* Accordion */
.accordion-button:focus {
    box-shadow: none;
}

/* Button Close */
.btn-close:focus {
    box-shadow: none;
}

/* Nav Link */
.nav-link {
    color: var(--bs-body-color);
}

.nav-link:focus,
.nav-link:hover {
    color: var(--bs-primary);
    text-decoration: none;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    background-color: var(--bs-primary);
}

/* Pagination */
.active>.page-link,
.page-link.active {
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
}

.page-item:last-child .page-link {
    color: var(--bs-primary);
}

.page-link:focus {
    box-shadow: none;
}

/* Pagination */

.c_radio>label {
    cursor: pointer;
    width: 167px;
}

.c_radio>label input[type=checkbox],
.c_radio>label input[type=radio] {
    position: absolute;
    opacity: 0;
}

.c_radio>label input[type=checkbox]:checked+.card,
.c_radio>label input[type=radio]:checked+.card {
    transition: ease-in .1s;
    border: 1px dashed var(--bs-primary);
    background: rgba(var(--bs-primary-rgb), .15);
}

.progress,
.progress-stacked {
    --bs-progress-bar-bg: var(--bs-primary);
}

.pagination {
    --bs-pagination-color: var(--bs-primary);
    --bs-pagination-active-bg: var(--bs-primary);
    --bs-pagination-active-border-color: var(--bs-primary);
}

.accordion {
    --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);
    --bs-accordion-active-bg: rgba(var(--bs-primary-rgb), .15);
}

.list-group {
    --bs-list-group-active-bg: var(--bs-primary);
    --bs-list-group-active-border-color: var(--bs-primary);
}

.btn-success {
    --bs-btn-bg: var(--bs-success);
    --bs-btn-border-color: var(--bs-success);
    ;
    --bs-btn-hover-bg: #157347;
    --bs-btn-hover-border-color: var(--bs-success);
    ;
    --bs-btn-active-bg: var(--bs-success);
    ;
    --bs-btn-active-border-color: var(--bs-success);
    ;
    --bs-btn-disabled-bg: var(--bs-success);
    ;
    --bs-btn-disabled-border-color: var(--bs-success);
    ;
}

code {
    color: var(--bs-primary);
}

.tag-hover a:hover {
    background: var(--dynamic-color);
    color: var(--bs-white);
    transition: var(--transition-3s);
}

.owl-carousel .owl-nav {
    display: none !important;
}

.owl-carousel .owl-dots {
    margin-top: 10px;
}

.owl-theme .owl-dots .owl-dot {
    display: inline-block;
    zoom: 1;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
    background: var(--bs-primary);
}

.owl-theme .owl-dots .owl-dot span {
    width: 10px;
    height: 10px;
    margin: 5px 7px;
    background: #d6d6d6;
    display: block;
    -webkit-backface-visibility: visible;
    transition: opacity .2s ease;
    border-radius: 30px;
}

/* Image file input css */
.file-input input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.file-input label:hover {
    cursor: pointer;
    color: var(--primary-color);
}

.image-input {
    background-repeat: no-repeat;
    background-size: cover;
}

.image-input .avatar-wrapper {
    background-repeat: no-repeat;
    background-size: cover !important;
    width: 100%;
    height: 100%;
}

.image-input.avatar.lg .file-input {
    bottom: -5px;
    right: -5px;
}

.image-input .file-input label {
    background: var(--card-color);
    text-align: center;
    height: 24px;
    width: 24px;
    line-height: 24px;
    border-radius: 24px;
}

/* Input tage */
.bootstrap-tagsinput {
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    background-color: var(--bs-body-bg);
    box-shadow: none;
    padding: .75rem;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
}

.bootstrap-tagsinput .tag {
    background-color: rgba(var(--bs-primary-rgb), .1);
    color: var(--primary-color);
    white-space: nowrap;
    padding: 3px 8px;
    border-radius: 6px;
}

.bootstrap-tagsinput .tag:hover {
    background-color: var(--bs-primary);
    color: var(--bs-white);
}

.bootstrap-tagsinput>input {
    flex-grow: 1 !important;
}

/* table list and mobile grid view */
.table-row-grid tr {
    border-bottom: 1px solid var(--bs-border-color);
    border-radius: 1rem;
    padding: 1rem;
}

.table-row-grid tr:hover {
    background: rgba(var(--bs-primary-rgb), .1);
}

.table-row-grid tr td {
    background: transparent;
}

/* Custom Pills */
.custom-pills .nav-link.active:hover,
.custom-pills .nav-link.active {
    background: rgba(var(--bs-primary-rgb), .1);
    color: var(--bs-body-color);
}

.custom-pills .nav-link:hover {
    background: transparent;
    color: var(--bs-body-color);
}

.swal2-show {
    border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/base.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,aAAa;IACb,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,qEAAqE;AACzE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,eAAe;AACf;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAEhC;AACJ;;AAEA,WAAW;AACX;IACI,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;AACvC;;AAEA,WAAW;;AAEX,YAAY;AACZ;;;;;IAKI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;;;;;IAKI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,4BAA4B;AAC5B;;IAEI,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;IACjC,wCAAwC;IACxC,oCAAoC;IACpC,8CAA8C;IAC9C,qCAAqC;IACrC,+CAA+C;IAC/C,0CAA0C;IAC1C,iDAAiD;AACrD;;AAEA;IACI,iCAAiC;IACjC,gDAAgD;IAChD,iDAAiD;AACrD;;AAEA,WAAW;;AAEX,8BAA8B;AAC9B;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA,WAAW;AACX;IACI,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA,iBAAiB;AACjB;IACI,+BAA+B;IAC/B,yDAAyD;AAC7D;;AAEA;IACI,8CAA8C;AAClD;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;;IAEI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;AACpB;;AAEA,aAAa;AACb;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA,eAAe;AACf;;IAEI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,eAAe;;AAEf;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,uBAAuB;IACvB,oCAAoC;IACpC,4CAA4C;AAChD;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;IACI,wCAAwC;IACxC,4CAA4C;IAC5C,sDAAsD;AAC1D;;AAEA;IACI,oFAAoF;IACpF,0DAA0D;AAC9D;;AAEA;IACI,4CAA4C;IAC5C,sDAAsD;AAC1D;;AAEA;IACI,8BAA8B;IAC9B,wCAAwC;;IAExC,0BAA0B;IAC1B,8CAA8C;;IAE9C,qCAAqC;;IAErC,+CAA+C;;IAE/C,uCAAuC;;IAEvC,iDAAiD;;AAErD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,OAAO;AACX;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oCAAoC;IACpC,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,iCAAiC;IACjC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,2DAA2D;IAC3D,sCAAsC;IACtC,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,iDAAiD;IACjD,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,oCAAoC;AACpC;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;;IAEI,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* Links */\na {\n    color: var(--bs-body-color);\n    text-decoration: none;\n}\n\na:hover {\n    color: var(--bs-primary);\n}\n\na:focus,\na:focus-within,\na:focus-visible {\n    outline: none;\n    box-shadow: none;\n}\n\n/* Colors */\n.bg-light-pink {\n    background: linear-gradient(97.59deg, #F4EDFA 4.58%, #DDD3E5 100.08%);\n}\n\n.bg-light-green {\n    background: linear-gradient(97.03deg, #EDFAF2 1.08%, #D1E0D7 99.84%);\n}\n\n.bg-light-blue {\n    background: linear-gradient(96.64deg, #EDF3FA 0.59%, #CBD3DC 99.22%);\n}\n\n.bg-light-orange {\n    background: linear-gradient(97.54deg, #FAEDED 2.68%, #E8DADA 98.28%);\n}\n\n.bg-light-gray {\n    background-color: var(--light-gray) !important;\n}\n\n.bg-card {\n    background-color: var(--bs-card-bg) !important;\n}\n\n.border-bg {\n    background: var(--bs-border-color);\n}\n\n.text-black-50 {\n    color: var(--text-black-50) !important;\n}\n\n/* Typography */\n.fs-0 {\n    font-size: 0px;\n}\n\n.fs-12 {\n    font-size: 12px;\n}\n\n.fs-14 {\n    font-size: 14px;\n}\n\n.fs-18 {\n    font-size: 18px;\n}\n\n.fs-20 {\n    font-size: 20px;\n}\n\n.fs-24 {\n    font-size: 24px;\n}\n\n.lh-20 {\n    line-height: 20px;\n}\n\n.lh-28 {\n    line-height: 28px;\n}\n\n.minw-190 {\n    min-width: 190px;\n}\n\n.form-label {\n    margin-bottom: .2rem;\n    font-size: 14px;\n    opacity: .7;\n}\n\n.drod-arrow-none::after {\n    display: none;\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n    background-color: var(--bs-primary);\n}\n\n.row-deck>[class*=col-] {\n    display: flex;\n}\n\n.row-deck>.col .card,\n.row-deck>[class*=col-] .card {\n    flex: 1 1 auto;\n}\n\n/* Table css */\n.table-nowrap tr td {\n    white-space: nowrap;\n}\n\n/* Avatar */\n.avatar.xs {\n    min-width: 18px;\n    width: 18px;\n    height: 18px;\n}\n\n.avatar.sm {\n    min-width: 24px;\n    width: 24px;\n    height: 24px;\n}\n\n.avatar.md {\n    min-width: 32px;\n    width: 32px;\n    height: 32px;\n}\n\n.avatar.lg {\n    min-width: 46px;\n    width: 46px;\n    height: 46px;\n}\n\n.avatar.xl {\n    min-width: 60px;\n    width: 60px;\n    height: 60px;\n}\n\n.avatar.xxl {\n    min-width: 120px;\n    width: 120px;\n    height: 120px;\n}\n\n.thumbnail {\n    background-color: var(--bs-primary);\n}\n\n.avatar-group {\n    padding-left: 16px;\n}\n\n.avatar-group .avatar-item.sm {\n    margin-left: -5px;\n}\n\n.avatar-group .avatar-item.md {\n    margin-left: -10px;\n}\n\n.avatar-group .avatar-item.lg {\n    margin-left: -16px;\n}\n\n.avatar-group .avatar-item:hover {\n    z-index: 99;\n    transition: var(--transition-3s);\n    -webkit-transform: translateY(-2px);\n    transform: translateY(-2px)\n}\n\n/* Border */\n.border-dashed {\n    border-style: dashed !important;\n}\n\n.border-top-dashed {\n    border-top-style: dashed !important;\n}\n\n/* Border */\n\n/* Buttons */\n.btn-check:checked+.btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check)+.btn:active {\n    border-color: transparent;\n}\n\n.btn-check:checked+.btn:focus-visible,\n.btn.active:focus-visible,\n.btn.show:focus-visible,\n.btn:first-child:active:focus-visible,\n:not(.btn-check)+.btn:active:focus-visible {\n    box-shadow: none;\n}\n\n.btn:focus-visible,\n.nav-link:focus-visible {\n    box-shadow: none;\n}\n\n/* Buttons Primary */\n.btn-primary,\n.btn-primary:focus,\n.btn-primary:hover,\n.btn-primary:active,\n.btn.btn-primary:first-child:active {\n    background-color: var(--bs-primary);\n    border-color: var(--bs-primary);\n}\n\n.btn-primary:hover {\n    transition: var(--transition-3s);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Buttons Primary Outline */\n.btn-outline-primary,\n.btn-outline-primary:focus {\n    color: var(--bs-primary);\n    border-color: var(--bs-primary);\n}\n\n.btn-outline-primary {\n    --bs-btn-color: var(--bs-primary);\n    --bs-btn-border-color: var(--bs-primary);\n    --bs-btn-hover-bg: var(--bs-primary);\n    --bs-btn-hover-border-color: var(--bs-primary);\n    --bs-btn-active-bg: var(--bs-primary);\n    --bs-btn-active-border-color: var(--bs-primary);\n    --bs-btn-disabled-color: var(--bs-primary);\n    --bs-btn-disabled-border-color: var(--bs-primary);\n}\n\n.btn-link {\n    --bs-btn-color: var(--bs-primary);\n    --bs-btn-hover-color: var(--bs-link-hover-color);\n    --bs-btn-active-color: var(--bs-link-hover-color);\n}\n\n/* button */\n\n/* On Hover SVG stroke witdh */\n.hover-svg svg path {\n    stroke: var(--bs-body-color);\n    transition: var(--transition-3s);\n}\n\n.hover-svg:hover svg path {\n    stroke-width: 2px;\n    stroke: var(--bs-primary);\n    transition: var(--transition-3s);\n}\n\n.hover-svg.active svg path {\n    stroke: inherit;\n}\n\n.text-success:hover svg path {\n    stroke-width: 2px;\n    stroke: var(--bs-success);\n    transition: var(--transition-3s);\n}\n\n.text-primary:hover svg path {\n    stroke-width: 2px;\n    stroke: var(--bs-primary);\n    transition: var(--transition-3s);\n}\n\n.text-secondary:hover svg path {\n    stroke-width: 2px;\n    stroke: var(--bs-secondary);\n    transition: var(--transition-3s);\n}\n\n.text-danger:hover svg path {\n    stroke-width: 2px;\n    stroke: var(--bs-danger);\n    transition: var(--transition-3s);\n}\n\n/* Resize */\n.resize-none {\n    resize: none;\n}\n\n/* Page Breadcrumbs */\n.page-breadcrumbs {\n    background-color: var(--bs-card-bg);\n    font-size: 18px;\n    position: sticky;\n    top: 78px;\n    z-index: 1021;\n}\n\n.page-breadcrumbs .back-btn {\n    min-width: 221px;\n    border-right: 1px solid var(--bs-border-color);\n}\n\n/* Form Control */\n.form-select:focus {\n    border-color: var(--bs-primary);\n    box-shadow: 0 0 0 .25rem rgba(var(--bs-primary-rgb), .25);\n}\n\n.form-control:hover {\n    border-color: rgba(var(--bs-primary-rgb), .25);\n}\n\n.form-control:focus-visible,\n.form-select:focus-visible {\n    outline-offset: 3px;\n    outline-width: 1px;\n    outline-style: dashed;\n    outline-color: rgba(var(--bs-primary-rgb), .5);\n}\n\n.form-control:focus,\n.form-check-input:focus {\n    box-shadow: none;\n    border-color: var(--bs-primary);\n}\n\n.control-group:has(textarea:focus) label,\n.control-group:has(select:focus) label,\n.control-group:has(input:focus) label {\n    color: var(--bs-primary);\n}\n\n.form-control-lg,\n.form-select-lg {\n    padding: .9rem 1rem;\n    font-size: 1rem;\n}\n\n\n.form-check-input:checked {\n    background-color: var(--bs-primary);\n    border-color: var(--bs-primary);\n}\n\n.form-check-input {\n    width: 1.3em;\n    height: 1.3em;\n    margin: 0;\n}\n\ninput[type=\"time\"],\ninput[type=\"date\"] {\n    text-align: left;\n    text-align-last: left;\n}\n\ninput[type=\"time\"]::-webkit-date-and-time-value,\ninput[type=\"date\"]::-webkit-date-and-time-value {\n    text-align: left;\n}\n\ninput[type=\"time\"]::-webkit-datetime-edit,\ninput[type=\"date\"]::-webkit-datetime-edit {\n    text-align: left;\n}\n\n/* Accordion */\n.accordion-button:focus {\n    box-shadow: none;\n}\n\n/* Button Close */\n.btn-close:focus {\n    box-shadow: none;\n}\n\n/* Nav Link */\n.nav-link {\n    color: var(--bs-body-color);\n}\n\n.nav-link:focus,\n.nav-link:hover {\n    color: var(--bs-primary);\n    text-decoration: none;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n    background-color: var(--bs-primary);\n}\n\n/* Pagination */\n.active>.page-link,\n.page-link.active {\n    background-color: var(--bs-primary);\n    border-color: var(--bs-primary);\n}\n\n.page-item:last-child .page-link {\n    color: var(--bs-primary);\n}\n\n.page-link:focus {\n    box-shadow: none;\n}\n\n/* Pagination */\n\n.c_radio>label {\n    cursor: pointer;\n    width: 167px;\n}\n\n.c_radio>label input[type=checkbox],\n.c_radio>label input[type=radio] {\n    position: absolute;\n    opacity: 0;\n}\n\n.c_radio>label input[type=checkbox]:checked+.card,\n.c_radio>label input[type=radio]:checked+.card {\n    transition: ease-in .1s;\n    border: 1px dashed var(--bs-primary);\n    background: rgba(var(--bs-primary-rgb), .15);\n}\n\n.progress,\n.progress-stacked {\n    --bs-progress-bar-bg: var(--bs-primary);\n}\n\n.pagination {\n    --bs-pagination-color: var(--bs-primary);\n    --bs-pagination-active-bg: var(--bs-primary);\n    --bs-pagination-active-border-color: var(--bs-primary);\n}\n\n.accordion {\n    --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);\n    --bs-accordion-active-bg: rgba(var(--bs-primary-rgb), .15);\n}\n\n.list-group {\n    --bs-list-group-active-bg: var(--bs-primary);\n    --bs-list-group-active-border-color: var(--bs-primary);\n}\n\n.btn-success {\n    --bs-btn-bg: var(--bs-success);\n    --bs-btn-border-color: var(--bs-success);\n    ;\n    --bs-btn-hover-bg: #157347;\n    --bs-btn-hover-border-color: var(--bs-success);\n    ;\n    --bs-btn-active-bg: var(--bs-success);\n    ;\n    --bs-btn-active-border-color: var(--bs-success);\n    ;\n    --bs-btn-disabled-bg: var(--bs-success);\n    ;\n    --bs-btn-disabled-border-color: var(--bs-success);\n    ;\n}\n\ncode {\n    color: var(--bs-primary);\n}\n\n.tag-hover a:hover {\n    background: var(--dynamic-color);\n    color: var(--bs-white);\n    transition: var(--transition-3s);\n}\n\n.owl-carousel .owl-nav {\n    display: none !important;\n}\n\n.owl-carousel .owl-dots {\n    margin-top: 10px;\n}\n\n.owl-theme .owl-dots .owl-dot {\n    display: inline-block;\n    zoom: 1;\n}\n\n.owl-theme .owl-dots .owl-dot.active span,\n.owl-theme .owl-dots .owl-dot:hover span {\n    background: var(--bs-primary);\n}\n\n.owl-theme .owl-dots .owl-dot span {\n    width: 10px;\n    height: 10px;\n    margin: 5px 7px;\n    background: #d6d6d6;\n    display: block;\n    -webkit-backface-visibility: visible;\n    transition: opacity .2s ease;\n    border-radius: 30px;\n}\n\n/* Image file input css */\n.file-input input {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n}\n\n.file-input label:hover {\n    cursor: pointer;\n    color: var(--primary-color);\n}\n\n.image-input {\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.image-input .avatar-wrapper {\n    background-repeat: no-repeat;\n    background-size: cover !important;\n    width: 100%;\n    height: 100%;\n}\n\n.image-input.avatar.lg .file-input {\n    bottom: -5px;\n    right: -5px;\n}\n\n.image-input .file-input label {\n    background: var(--card-color);\n    text-align: center;\n    height: 24px;\n    width: 24px;\n    line-height: 24px;\n    border-radius: 24px;\n}\n\n/* Input tage */\n.bootstrap-tagsinput {\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    border-radius: var(--bs-border-radius);\n    background-color: var(--bs-body-bg);\n    box-shadow: none;\n    padding: .75rem;\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2px;\n}\n\n.bootstrap-tagsinput .tag {\n    background-color: rgba(var(--bs-primary-rgb), .1);\n    color: var(--primary-color);\n    white-space: nowrap;\n    padding: 3px 8px;\n    border-radius: 6px;\n}\n\n.bootstrap-tagsinput .tag:hover {\n    background-color: var(--bs-primary);\n    color: var(--bs-white);\n}\n\n.bootstrap-tagsinput>input {\n    flex-grow: 1 !important;\n}\n\n/* table list and mobile grid view */\n.table-row-grid tr {\n    border-bottom: 1px solid var(--bs-border-color);\n    border-radius: 1rem;\n    padding: 1rem;\n}\n\n.table-row-grid tr:hover {\n    background: rgba(var(--bs-primary-rgb), .1);\n}\n\n.table-row-grid tr td {\n    background: transparent;\n}\n\n/* Custom Pills */\n.custom-pills .nav-link.active:hover,\n.custom-pills .nav-link.active {\n    background: rgba(var(--bs-primary-rgb), .1);\n    color: var(--bs-body-color);\n}\n\n.custom-pills .nav-link:hover {\n    background: transparent;\n    color: var(--bs-body-color);\n}\n\n.swal2-show {\n    border-radius: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
